import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, viewChild } from '@angular/core';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonContainerComponent } from '@reconcept-platform/shared/ui/standalone/button';
import { RcpPopoverDirective } from '@reconcept-platform/shared/ui/standalone/popover';
import { ButtonExpandableOverlayButtonComponent } from './button/button-expandable-overlay-button.component';

@Component({
  selector: 'rcp-button-expandable-overlay',
  templateUrl: './button-expandable-overlay.component.html',
  styles: `
    @use 'variables' as *;

    .overlay-content {
      border: solid 1px var(--col-lines);
      border-radius: var(--br);
      background-color: var(--col-bg-base);
      width: fit-content;
    }
  `,
  imports: [FontAwesomeModule, ButtonExpandableOverlayButtonComponent, ButtonContainerComponent, RcpPopoverDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ButtonExpandableOverlayComponent {
  @Input() isDisabled = false;
  @Input() isActive = false;
  @Input() icon: IconProp;
  @Input() iconRightRotate = true;

  @Output() overlayToggle = new EventEmitter<boolean>();

  tooltip = viewChild(RcpPopoverDirective);

  close(event?: MouseEvent) {
    event?.stopPropagation();
    // @ts-expect-error TS2532 object possibly undefined
    this.tooltip().hide();
    this.overlayToggle.emit(this.isActive);
  }

  toggleIsActive(isActive: boolean) {
    this.isActive = isActive;
    this.overlayToggle.emit(this.isActive);
  }
}
